'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('BrowseChannelCtrl', BrowseChannelCtrl);

  BrowseChannelCtrl.$inject = ['$stateParams', '$state', 'page', 'focus'];

  /* @ngInject */
  function BrowseChannelCtrl($stateParams, $state, page, focus) {
    if (!$stateParams.channel || !$stateParams.pageTag) {
      $state.go('^.view');
    }

    focus.byClassName('.channel-title', 500);

    this.channel = $stateParams.channel;
    this.tag = $stateParams.pageTag;
    this.page = page;
  }
})();